/**
 * 退市整理期，剩余交易日提示条
 */
import React, { useEffect, useState } from "react"
import { quotedata } from "../../shared/quotedata"
import { GetDelistingDay } from "../../../modules/quote/web"

export function DelistingTips(props:{
  quotedata: quotedata,
  detail_data:any
}){

  // console.info(props.quotedata)
  // console.info(props.detail_data)

  let is_tszl = props.detail_data ? (props.detail_data.f177 & 2048) : false

  const [message, setMessage ] = useState('')


  const getData = async()=>{
    let back = await GetDelistingDay(props.quotedata.market.toString(), props.quotedata.code)
    if(back && back.CONTENT) setMessage(back.CONTENT)
  }
  
  useEffect(()=>{
    if(is_tszl){
      getData()
    }
  }, [is_tszl]);

  if(props.detail_data == undefined){
    return <></>
  }

  //进入退市整理期
  if(message){
    return (
      <div className="cme-rule" style={{textAlign: 'center', fontSize: '80%', backgroundColor: '#FFCC75', padding: '5px', color: '#333'}}>{message}</div>
    )    
  }



  return (
    <></>
  )
}